(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hechter-shirt-fitguide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-hechter-fitguide]');
    roots.forEach((root) => {
      const allowed = ['modern', 'shape'];
      const tabs = Array.from(root.querySelectorAll('[data-fit-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-fit-panel]'));
      const copies = Array.from(root.querySelectorAll('[data-fit-copy]'));

      const activate = (requested, updateUrl = false) => {
        const fit = allowed.includes(requested) ? requested : (root.dataset.defaultFit || 'modern');
        root.dataset.activeFit = fit;
        tabs.forEach((tab) => {
          const active = tab.dataset.fitTab === fit;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.fitPanel !== fit; });
        copies.forEach((copy) => { copy.classList.toggle('is-active', copy.dataset.fitCopy === fit); });
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('fit', fit);
          window.history.replaceState({}, '', url);
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.fitTab, true));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = (index + direction + tabs.length) % tabs.length;
          tabs[next].focus();
          activate(tabs[next].dataset.fitTab, true);
        });
      });

      const queryFit = new URLSearchParams(window.location.search).get('fit');
      activate(queryFit || root.dataset.defaultFit || 'modern');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
